export const routes = {
    "/gpSpecialistInfo": {
        title: "GP/Specialist info",
        "/create": {
            title: "Create"
        },
        "/:gpSpecialistInfoId": {
            title: "Details",
            "/edit": {
                title: "Edit"
            }
        }
    }
};
